import { useQuery } from '@tanstack/react-query';
import { getOfferedClusters } from '../../services/offeredCluster';
import { QueryKey } from '../../enums/QueryKey';

export function useOfferedClusters() {
    const { data, ...rest } = useQuery({
        queryKey: [QueryKey.OfferedClusters],
        queryFn: getOfferedClusters,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
    });

    return {
        data: data || [],
        ...rest,
    };
}
